import typographyStyles from "@moodys/mdc-frontend.theming.fonts/typography.module.scss";
import { createTheme, responsiveFontSizes } from "@mui/material/styles";
const fontWeightLight = Number(typographyStyles.fontWeightLight);
const fontWeightBook = Number(typographyStyles.fontWeightRegular);
const fontWeightMedium = Number(typographyStyles.fontWeightMedium);
const fontWeightSemiBold = Number(typographyStyles.fontWeightSemiBold);
const fontWeightBold = Number(typographyStyles.fontWeightBold);
const headingsLineHeight = 1.3;
const BASE_FONT_SIZE = 16;
const FONT_SIZES_IN_PX = {
    h1: 28,
    h2: 24,
    h3: 20,
    h4: 18,
    h5: 16,
    h6: 14,
    subtitle1: 20,
    subtitle2: 18,
    body1: 16,
    body2: 14,
    button: 14,
    caption: 12,
    overline: 12,
    footnote: 12,
    note: 12,
    display1: 60,
    display2: 42,
    displayCopy: 20,
    metadata: 12,
    attribution: 12,
};
const getTypography = () => {
    const theme = createTheme({
        typography: {
            htmlFontSize: BASE_FONT_SIZE,
        },
    });
    const { pxToRem } = theme.typography;
    const typographyOption = {
        htmlFontSize: BASE_FONT_SIZE,
        fontFamily: typographyStyles.fontFamily,
        fontWeightLight,
        fontWeightBook,
        fontWeightMedium,
        fontWeightSemiBold,
        fontWeightBold,
        h1: {
            fontWeight: fontWeightSemiBold,
            fontSize: pxToRem(FONT_SIZES_IN_PX.h1),
            lineHeight: headingsLineHeight,
            marginBottom: "0.35em",
        },
        h2: {
            fontWeight: fontWeightSemiBold,
            fontSize: pxToRem(FONT_SIZES_IN_PX.h2),
            lineHeight: headingsLineHeight,
            marginBottom: "0.35em",
        },
        h3: {
            fontWeight: fontWeightSemiBold,
            fontSize: pxToRem(FONT_SIZES_IN_PX.h3),
            lineHeight: headingsLineHeight,
            marginBottom: "0.35em",
        },
        h4: {
            fontWeight: fontWeightSemiBold,
            fontSize: pxToRem(FONT_SIZES_IN_PX.h4),
            lineHeight: headingsLineHeight,
            marginBottom: "0.35em",
        },
        h5: {
            fontWeight: fontWeightSemiBold,
            fontSize: pxToRem(FONT_SIZES_IN_PX.h5),
            lineHeight: headingsLineHeight,
            marginBottom: "0.35em",
        },
        h6: {
            fontWeight: fontWeightSemiBold,
            fontSize: pxToRem(FONT_SIZES_IN_PX.h6),
            lineHeight: headingsLineHeight,
            marginBottom: "0.35em",
        },
        subtitle1: {
            fontWeight: fontWeightBook,
            fontSize: pxToRem(FONT_SIZES_IN_PX.subtitle1),
            lineHeight: 1.5,
            marginBottom: "0.35em",
        },
        subtitle2: {
            fontWeight: fontWeightBook,
            fontSize: pxToRem(FONT_SIZES_IN_PX.subtitle2),
            lineHeight: 1.5,
            marginBottom: "0.35em",
        },
        body1: {
            fontWeight: fontWeightBook,
            fontSize: pxToRem(FONT_SIZES_IN_PX.body1),
            lineHeight: 1.5,
            marginBottom: "1em",
        },
        body2: {
            fontWeight: fontWeightBook,
            fontSize: pxToRem(FONT_SIZES_IN_PX.body2),
            lineHeight: 1.5,
            marginBottom: "1em",
        },
        button: {
            fontWeight: fontWeightSemiBold,
            fontSize: pxToRem(FONT_SIZES_IN_PX.button),
            textTransform: "none",
            lineHeight: 1.5,
        },
        caption: {
            fontWeight: fontWeightMedium,
            fontSize: pxToRem(FONT_SIZES_IN_PX.caption),
            letterSpacing: 0.4,
            lineHeight: 1.6,
            marginBottom: "0.35em",
        },
        overline: {
            fontWeight: fontWeightBook,
            fontSize: pxToRem(FONT_SIZES_IN_PX.overline),
            textTransform: "uppercase",
            letterSpacing: 1,
            lineHeight: 2.0,
            marginBottom: "0.35em",
        },
        footnote: {
            fontFamily: typographyStyles.fontFamily,
            fontWeight: fontWeightBook,
            fontSize: pxToRem(FONT_SIZES_IN_PX.footnote),
            lineHeight: 1.5,
            marginBottom: "0.35em",
            color: theme.palette.text.secondary,
        },
        note: {
            fontFamily: typographyStyles.fontFamily,
            fontWeight: fontWeightBook,
            fontSize: pxToRem(FONT_SIZES_IN_PX.note),
            lineHeight: 1.5,
            marginBottom: "0.35em",
            color: theme.palette.text.secondary,
        },
        display1: {
            fontWeight: fontWeightSemiBold,
            fontFamily: typographyStyles.fontFamily,
            fontSize: pxToRem(FONT_SIZES_IN_PX.display1),
            lineHeight: headingsLineHeight,
            marginBottom: "0.35em",
        },
        display2: {
            fontWeight: fontWeightSemiBold,
            fontFamily: typographyStyles.fontFamily,
            fontSize: pxToRem(FONT_SIZES_IN_PX.display2),
            lineHeight: headingsLineHeight,
            marginBottom: "0.35em",
        },
        displayCopy: {
            fontWeight: fontWeightBook,
            fontFamily: typographyStyles.fontFamily,
            fontSize: pxToRem(FONT_SIZES_IN_PX.displayCopy),
            lineHeight: headingsLineHeight,
            marginBottom: "0.35em",
        },
        metadata: {
            fontWeight: fontWeightMedium,
            fontFamily: typographyStyles.fontFamily,
            fontSize: pxToRem(FONT_SIZES_IN_PX.metadata),
            lineHeight: 1.6,
            letterSpacing: "0.4px",
            marginBottom: "0.35em",
            color: theme.palette.text.secondary,
        },
        attribution: {
            fontWeight: fontWeightSemiBold,
            fontFamily: typographyStyles.fontFamily,
            fontSize: pxToRem(FONT_SIZES_IN_PX.attribution),
            lineHeight: 1.5,
            letterSpacing: "0.4px",
            marginBottom: "0.35em",
            color: theme.palette.text.secondary,
        },
    };
    const { typography: typographyWithResponsiveFontSizes } = responsiveFontSizes(createTheme({
        typography: typographyOption,
    }));
    return typographyWithResponsiveFontSizes;
};
export const typography = getTypography();
export const getTypographyFontSizes = ({ htmlFontSize, includeResponsiveStyles, }) => {
    const theme = createTheme({
        typography: {
            htmlFontSize,
        },
    });
    const { pxToRem } = theme.typography;
    const baseTypographyOption = {
        htmlFontSize: theme.typography.htmlFontSize,
        fontSize: theme.typography.fontSize,
    };
    const typography = Object.keys(FONT_SIZES_IN_PX).reduce((accum, fontSizeKey) => {
        return {
            ...accum,
            [fontSizeKey]: {
                fontSize: pxToRem(FONT_SIZES_IN_PX[fontSizeKey]),
            },
        };
    }, baseTypographyOption);
    if (!includeResponsiveStyles) {
        return {
            ...typography,
            pxToRem
        };
    }
    const { typography: typographyWithResponsiveFontSizes } = responsiveFontSizes(createTheme({
        typography,
    }));
    const typographyWithMediaObjects = Object.keys(FONT_SIZES_IN_PX).reduce((accum, fontSizeKey) => {
        const withMedia = typographyWithResponsiveFontSizes[fontSizeKey];
        const fontSizeObj = Object.keys(withMedia).reduce((accum, withMediaKey) => {
            if (!withMediaKey.startsWith("@media") && withMediaKey !== "fontSize")
                return accum;
            return {
                ...accum,
                [withMediaKey]: withMedia[withMediaKey],
            };
        }, {});
        return {
            ...accum,
            [fontSizeKey]: fontSizeObj,
        };
    }, baseTypographyOption);
    return {
        ...typographyWithMediaObjects,
        pxToRem
    };
};
//# sourceMappingURL=typography.js.map